import { Component } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';

import AppGuidelinesModule from '../app-guidelines.module';

@Component({
    selector: 'app-slider-with-inputs',
    imports: [MatSliderModule, MatInputModule, AppGuidelinesModule],
    templateUrl: './slider-with-inputs.component.html',
    styleUrls: ['./slider-with-inputs.component.less'],
})
class SliderWithInputsComponent {}

export default SliderWithInputsComponent;
